import React from 'react';
import {useNavigate} from 'react-router-dom';

import Logo from '@assets/images/logo.svg';
import {LogoGrid} from './LogoComponentStyles';
import {PUBLIC_ROUTES} from 'src/routes/RouteConstants';
import {BASE_ROUTE, IS_FROM_EPIC, IS_FROM_ATHENA} from 'src/routes/BaseRoute';
import EncryptUtils from 'src/utils/EncryptUtils';

const LogoComponent = (): React.ReactElement => {
  const navigate = useNavigate();
  const isFromEpic = EncryptUtils.getDecryptedData(
    location?.search,
    IS_FROM_EPIC
  );

  const isFromAthena = EncryptUtils.getDecryptedData(
    location?.search,
    IS_FROM_ATHENA
  );

  const goToLoginPage = () => {
    if (!isFromEpic) {
      navigate(`/${BASE_ROUTE}/` + PUBLIC_ROUTES.LOGIN);
    } else if (!isFromAthena) {
      navigate(`/${BASE_ROUTE}/` + PUBLIC_ROUTES.LOGIN);
    }
  };

  return (
    <LogoGrid>
      <img
        style={{
          height: '45px',
          cursor: isFromEpic || isFromAthena ? 'auto' : 'pointer',
          margin: '0 auto'
        }}
        src={Logo}
        alt="logo"
        onClick={goToLoginPage}
      />
    </LogoGrid>
  );
};

export default LogoComponent;
